var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.showDialog,
        width: "480px",
        "before-close": _vm.handleCancel
      },
      on: {
        "update:visible": function($event) {
          _vm.showDialog = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
        [_vm._v("切换支付方式")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tips-wrap" }, [
        _c("span", [_vm._v("1、只有状态为“待修改”的代采单才能切换。")]),
        _vm._v(" "),
        _c("span", [
          _vm._v("2、A1表头=代采订单编号，从A2~A正无限，填入代采单编号。")
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("3、切换为“上传回执”会同时完成支付。")]),
        _vm._v(" "),
        _c("span", [_vm._v("4、单次最多200个ID。")])
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "tableForm",
          attrs: {
            model: _vm.checkForm,
            "label-width": "100px",
            rules: _vm.rules
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "导入切换为:", prop: "methods" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.checkForm.methods,
                    callback: function($$v) {
                      _vm.$set(_vm.checkForm, "methods", $$v)
                    },
                    expression: "checkForm.methods"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v("转账支付 ")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("上传回执 ")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkForm.methods === "2",
                  expression: "checkForm.methods === '2'"
                }
              ],
              attrs: { label: "上传回执:", prop: "receipt" }
            },
            [
              _c("YsUpload", {
                attrs: { max: 1 },
                model: {
                  value: _vm.checkForm.receipt,
                  callback: function($$v) {
                    _vm.$set(_vm.checkForm, "receipt", $$v)
                  },
                  expression: "checkForm.receipt"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "info", size: "small" },
              on: { click: _vm.handleCancel }
            },
            [_vm._v("\n      取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-upload",
            {
              ref: "uploadUpdateCutPayRef",
              staticStyle: { display: "inline-block", "margin-left": "10px" },
              attrs: {
                max: 1,
                name: "excel",
                data: _vm.checkForm,
                "upload-type": "excel",
                "show-file-list": false,
                "before-upload": _vm.beforeUpload,
                action: _vm.actionUrl,
                "with-credentials": true,
                "on-success": _vm.importUpdateCutPaySuccess,
                "on-error": function(data) {
                  return _vm.$message.error("导入发生错误, 请及时联系技术")
                }
              }
            },
            [
              _c("el-button", { attrs: { size: "small", type: "success" } }, [
                _vm._v("导入代采单")
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e435e6d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e435e6d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CutPayModeDialog.vue
// module id = null
// module chunks = 